__turbopack_context__.v({
  "actions": "WalletBalance-module__6V_m1q__actions",
  "balanceContainer": "WalletBalance-module__6V_m1q__balanceContainer",
  "balanceLabel": "WalletBalance-module__6V_m1q__balanceLabel",
  "bitcoinTickerIcon": "WalletBalance-module__6V_m1q__bitcoinTickerIcon",
  "description": "WalletBalance-module__6V_m1q__description",
  "icon": "WalletBalance-module__6V_m1q__icon",
  "root": "WalletBalance-module__6V_m1q__root",
  "topupButton": "WalletBalance-module__6V_m1q__topupButton",
  "topupLabel": "WalletBalance-module__6V_m1q__topupLabel",
  "walletBalanceContainer": "WalletBalance-module__6V_m1q__walletBalanceContainer",
  "walletHeader": "WalletBalance-module__6V_m1q__walletHeader",
});
